import { render, staticRenderFns } from "./AdminResultsPage.vue?vue&type=template&id=1cb7c2b0&scoped=true&"
import script from "./AdminResultsPage.vue?vue&type=script&lang=js&"
export * from "./AdminResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7c2b0",
  null
  
)

export default component.exports